import React from "react";
import ChartUi from "./ChartUi";
import Box from "../../../../components/box/Box";
import BoxLoader from "../../../../components/loaders/BoxLoader";

const ChartService = ({data, sectors, byValue}) => {

    return (
        <Box rwFreeHeight={true} disableHeader={true} loaded={true} leftBoxClassName={'w-100 bg-white p-20px'}
             height={'430px'}>
            {data ?
                <ChartUi
                    data={data}
                    sectors={sectors}
                    byValue={byValue}
                />
                :
                <BoxLoader
                    showMenu={false}
                    contentHeight={400}
                    className={'middle-box-content-full'}
                />
            }
        </Box>
    );
};

export default ChartService;